export const API_KEYS = [
  {
    id: 'key-1',
    name: 'Portfolio Integration Key',
    masked: 'sk_live_••••••••3f9a',
    environment: 'Production',
    createdBy: 'Sarah Mitchell',
    createdDate: '01 Sep 2025',
    lastUsed: '2 hours ago',
    expiry: 'No expiry',
    status: 'Active',
  },
  {
    id: 'key-2',
    name: 'Reporting Webhook Key',
    masked: 'sk_sand_••••••••8c2d',
    environment: 'Sandbox',
    createdBy: 'admin@seeddrive.demo',
    createdDate: '15 Oct 2025',
    lastUsed: 'Yesterday',
    expiry: 'Expires 15 Oct 2026',
    status: 'Active',
  },
  {
    id: 'key-3',
    name: 'Data Export Key',
    masked: 'sk_live_••••••••1e7b',
    environment: 'Production',
    createdBy: 'Sarah Mitchell',
    createdDate: '01 Jan 2025',
    lastUsed: '3 weeks ago',
    expiry: 'Expired 01 Dec 2025',
    status: 'Expired',
  },
];

export const WEBHOOKS = [
  {
    id: 'wh-1',
    url: 'https://api.example.com/••••••••/webhook',
    events: 'capital_call.created, deal.stage_changed',
    status: 'Active',
    lastTriggered: '1 hour ago',
  },
  {
    id: 'wh-2',
    url: 'https://hooks.partner.io/••••••••/events',
    events: 'document.uploaded, esg.alert_raised',
    status: 'Inactive',
    lastTriggered: '3 days ago',
  },
];

export const ACTIVE_SESSIONS = [
  {
    id: 'sess-1',
    device: 'Chrome on macOS',
    location: 'London, UK',
    ip: '82.132.45.201',
    lastActive: 'Now',
    isCurrent: true,
  },
  {
    id: 'sess-2',
    device: 'Safari on iPhone',
    location: 'Manchester, UK',
    ip: '82.132.45.202',
    lastActive: '2 hours ago',
    isCurrent: false,
  },
];

export const LOGIN_HISTORY = [
  { id: 'lh-1', datetime: '05 Mar 2026, 09:14', device: 'Chrome on macOS', location: 'London, UK', ip: '82.132.45.201', status: 'Successful' },
  { id: 'lh-2', datetime: '04 Mar 2026, 18:32', device: 'Safari on iPhone', location: 'Manchester, UK', ip: '82.132.45.202', status: 'Successful' },
  { id: 'lh-3', datetime: '04 Mar 2026, 11:05', device: 'Chrome on macOS', location: 'London, UK', ip: '82.132.45.201', status: 'Successful' },
  { id: 'lh-4', datetime: '03 Mar 2026, 22:47', device: 'Unknown Device', location: 'Amsterdam, NL', ip: '185.220.101.45', status: 'Failed' },
  { id: 'lh-5', datetime: '03 Mar 2026, 09:00', device: 'Chrome on macOS', location: 'London, UK', ip: '82.132.45.201', status: 'Successful' },
  { id: 'lh-6', datetime: '02 Mar 2026, 16:15', device: 'Firefox on Windows', location: 'London, UK', ip: '82.132.45.203', status: 'Successful' },
  { id: 'lh-7', datetime: '01 Mar 2026, 10:22', device: 'Chrome on macOS', location: 'London, UK', ip: '82.132.45.201', status: 'Successful' },
  { id: 'lh-8', datetime: '28 Feb 2026, 14:55', device: 'Safari on macOS', location: 'Edinburgh, UK', ip: '82.132.45.204', status: 'Successful' },
];

export const NOTIFICATION_TYPES = [
  { id: 'capital_calls', label: 'Capital Calls', icon: 'DollarSign' },
  { id: 'milestones', label: 'Milestones', icon: 'Flag' },
  { id: 'esg_alerts', label: 'ESG Alerts', icon: 'Leaf' },
  { id: 'documents', label: 'Documents', icon: 'FileText' },
  { id: 'deal_movements', label: 'Deal Movements', icon: 'TrendingUp' },
  { id: 'system', label: 'System', icon: 'Settings' },
];
